import { render } from "./HomeActionsBarAlbumTabs.vue?vue&type=template&id=4a2848c9&scoped=true"
import script from "./HomeActionsBarAlbumTabs.vue?vue&type=script&lang=js"
export * from "./HomeActionsBarAlbumTabs.vue?vue&type=script&lang=js"

import "./HomeActionsBarAlbumTabs.vue?vue&type=style&index=0&id=4a2848c9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a2848c9"

export default script